// extracted by mini-css-extract-plugin
export var email = "InputEmail-module--email--d503b";
export var sendButton = "InputEmail-module--sendButton--49b4b";